import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyTable,
  PolicyHyphenList,
  PolicyMenu,
  CaptionHide,
  PolicyHyphenListBox,
} from "styles/PolicyCommon";

const Privacy = () => {
  return (
    <PolicyContainer>
      <h1 className="hide">열달후에</h1>
      <PolicyTitle>[열달후에] 개인정보 처리방침</PolicyTitle>
      <PolicyVersion>ver.3.0</PolicyVersion>

      <PolicyText>
        ㈜커넥트아이(이하 ‘회사’라 함)는 정보주체의 개인정보보호를 매우
        중요시하며, 정보주체가 회사의 ‘열달후에’ 서비스(이하 ‘서비스‘라 함)를
        이용함과 동시에 온라인상에서 회사에 제공한 개인정보가 보호받을 수 있도록
        최선을 다하고 있습니다. 이에 회사는 「개인정보보호법」,
        「통신비밀보호법」, 「전기통신사업법」, 「정보통신망 이용촉진 및
        정보보호 등에 관한 법률」 등 정보통신서비스제공자가 준수하여야 할 관련
        법규 상의 개인정보보호 규정을 준수하고 있습니다.
      </PolicyText>
      <PolicyText>
        회사는 개인정보처리방침을 통하여 정보주체가 제공하는 개인정보가 어떠한
        용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가
        취해지고 있는지 알려드립니다. 또한 개인정보처리방침을 서비스 내 공지사항
        및 이용약관 화면에 공개함으로써 정보주체가 언제나 용이하게 보실 수
        있도록 조치하고 있습니다.
      </PolicyText>
      <PolicyText>
        회사의 개인정보처리방침은 정부의 법률 및 지침 변경이나 회사의 내부 방침
        변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보처리방침의
        지속적인 개선을 위하여 필요한 절차를 정하고 있습니다. 그리고
        개인정보처리방침을 개정하는 경우 회사는 개인정보처리방침 변경 시행
        7일전부터 사이트 공지사항을 통하여 공지하고 버전번호 및 개정일자 등을
        부여하여 개정된 사항을 정보주체가 쉽게 알아볼 수 있도록 하고 있습니다.
      </PolicyText>
      <PolicyText>
        개인정보처리방침의 상세 내용은 다음과 같은 내용을 담고 있습니다.
      </PolicyText>

      <PolicyMenu>
        <PolicyText>- 목 차 -</PolicyText>
        <ul>
          <li>
            <a href="#privacy01">01. 개인정보 수집에 대한 동의</a>
          </li>
          <li>
            <a href="#privacy02">02. 개인정보의 수집목적 및 이용목적</a>
          </li>
          <li>
            <a href="#privacy03">03. 수집하는 개인정보 항목 및 수집방법</a>
          </li>
          <li>
            <a href="#privacy04">04. 수집하는 개인정보의 보유 및 이용기간</a>
          </li>
          <li>
            <a href="#privacy05">05. 수집한 개인정보의 공유 및 제공</a>
          </li>
          <li>
            <a href="#privacy06">
              06. 정보주체 자신의 개인정보 관리(열람, 정정, 삭제 등)에 관한 사항
            </a>
          </li>
          <li>
            <a href="#privacy07">
              07. 개인정보 자동수집 장치의 설치·운영 및 그 거부에 관한 사항
            </a>
          </li>
          <li>
            <a href="#privacy08">08. 개인정보 파기 절차 및 방법</a>
          </li>
          <li>
            <a href="#privacy09">09. 가명정보의 처리 </a>
          </li>
          <li>
            <a href="#privacy10">
              10. 개인정보 관련 기술적 및 관리적 보호 대책
            </a>
          </li>
          <li>
            <a href="#privacy11">11. 개인정보의 위탁처리</a>
          </li>
          <li>
            <a href="#privacy12">
              12. 개인정보관련 의견수렴 및 불만처리에 관한 사항
            </a>
          </li>
          <li>
            <a href="#privacy13">13. 정보주체의 권리와 의무</a>
          </li>
          <li>
            <a href="#privacy14">14. 고객센터 안내</a>
          </li>
          <li>
            <a href="#privacy15">
              15. 개인정보 보호 책임자의 소속-성명 및 연락처
            </a>
          </li>
          <li>
            <a href="#privacy16">16. 본 개인정보처리방침의 적용 범위</a>
          </li>
          <li>
            <a href="#privacy17">17. 고지의 의무</a>
          </li>
        </ul>
      </PolicyMenu>

      <PolicySectionTitle id="privacy01">
        01. 개인정보 수집에 대한 동의
      </PolicySectionTitle>
      <PolicyText>
        회사는 정보주체가 회사의 개인정보처리방침 또는 개인정보 수집 동의,
        이용약관의 내용에 대하여 「동의」버튼 또는 「취소」버튼을 클릭할 수 있는
        절차 또는 체크박스 유무를 마련하여, 「동의」버튼 또는 체크박스 체크 시
        개인정보 수집에 대해 동의한 것으로 봅니다.
      </PolicyText>

      <PolicySectionTitle id="privacy02">
        02. 개인정보의 수집목적 및 이용목적
      </PolicySectionTitle>
      <PolicyText>
        "개인정보"라 함은 개인정보 보호법 제2조 제1호에 따라 살아 있는 개인에
        관한 정보로서 성명, 주민등록번호 및 영상 등을 통하여 개인을 알아볼 수
        있는 정보(해당 정보만으로는 특정 개인을 알아볼 수 없더라도 다른 정보와
        쉽게 결합하여 알아볼 수 있는 것을 포함한다)를 말합니다.
      </PolicyText>
      <PolicyText>
        회사는 이용자의 사전 동의 없이는 이용자의 개인 정보를 공개하지 않으며,
        수집된 정보는 아래와 같이 이용하고 있습니다. 원활한 양질의 서비스를
        제공하고자 마케팅(SMS, E-mail)을 시행할 수 있습니다.
      </PolicyText>
      <PolicyText>
        수집하는 개인정보의 수집 및 이용목적은 다음과 같습니다.
      </PolicyText>
      <PolicyList>
        <li>
          ① 회원가입 의사 확인, 이용자 식별, 연령 확인(성인 인증), 회원 탈퇴
          의사 확인 등 회원 관리를 위해 활용
        </li>
        <li>
          ② 이용자와 약속한 서비스 제공, 서비스 제공에 따른 본인 인증, 문의사항
          또는 불만 처리 및 회신, 공지사항 전달에 활용
        </li>
        <li>
          ③ 법령 및 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용
          행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위, 비인가 행위에
          대한 방지 및 제재, 계정도용 방지, 분쟁 조정을 위한 기록보존 등 이용자
          보호 및 안전한 서비스 운영에 활용
        </li>
        <li>
          ④ 서비스 이용 성향, 관심, 이용기록 분석 등을 반영한 신규 서비스 개발
          및 맞춤형 서비스 제공 등 서비스 개선에 활용
        </li>
        <li>
          ⑤ 이벤트 정보 및 참여기회 제공, 광고성 정보 제공 등 마케팅 및
          프로모션에 활용
        </li>
      </PolicyList>
      <PolicyText>
        위의 내용에 대한 동의를 거부할 수 있습니다. 다만, 이에 대한 동의를 하지
        않을 경우에는 신규 서비스나 이벤트 및 프로모션에 대한 안내를 받지 못할
        수 있음을 알려 드립니다.
      </PolicyText>

      <PolicySectionTitle id="privacy03">
        03. 수집하는 개인정보 항목 및 수집방법
      </PolicySectionTitle>
      <PolicyArticleTitle>가. 수집하는 개인정보의 항목</PolicyArticleTitle>
      <PolicyText>
        회사는 회원가입, 서비스 이용, 원활한 고객상담 등 아래와 같은 개인정보를
        수집하고 있습니다.
      </PolicyText>
      <PolicyList>
        <li>
          ① 회원 가입 시 수집되는 필수 및 선택 항목는 회원가입 의사 확인, 식별
          및 인증, 회원자격 유지 및 관리, 본인 확인, 서비스 부정이용 확인 및
          방지, 각종 고지 및 통지, 지역 맞춤 광고 및 정보 제공 등을 위해
          수집됩니다.
          <PolicyTable>
            <CaptionHide>
              가입 방식에 따른 수집 항목, 보유 및 이용기간 안내
            </CaptionHide>
            <colgroup>
              <col style={{ width: "25%" }} />
              <col />
              <col style={{ width: "25%" }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">가입 방식</th>
                <th scope="col">수집 항목</th>
                <th scope="col">보유 및 이용 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>일반 회원가입(이메일 회원가입)</td>
                <td>
                  [필수] 아이디(이메일 정보), 비밀번호, 대표 지역
                  정보(시/군/구), 본인 인증 정보 (이름, 생년월일, 성별, 휴대폰
                  번호, 본인 확인값(CI, DI), 이동통신사)
                </td>
                <td rowSpan={4}>
                  <strong>회원 탈퇴 시 즉시 삭제</strong>
                </td>
              </tr>
              <tr>
                <td>카카오 로그인</td>
                <td>
                  [필수] 카카오계정(이메일), 대표 지역 정보(시/군/구), 본인 인증
                  정보 (이름, 생년월일, 성별, 휴대폰 번호, 본인 확인값(CI, DI),
                  이동통신사)
                  <br />
                  [선택] 성별, 생일, 이름
                </td>
              </tr>
              <tr>
                <td>네이버 로그인</td>
                <td>
                  [필수] 이메일 주소, 대표 지역 정보(시/군/구), 본인 인증 정보
                  (이름, 생년월일, 성별, 휴대폰 번호, 본인 확인값(CI, DI),
                  이동통신사)
                  <br />
                  [선택] 성별
                </td>
              </tr>
              <tr>
                <td>애플 로그인</td>
                <td>
                  [필수] 대표 지역 정보(시/군/구), 본인 인증 정보 (이름,
                  생년월일, 성별, 휴대폰 번호, 본인 확인값(CI, DI), 이동통신사)
                  <br />
                  [선택] 애플 ID
                </td>
              </tr>
            </tbody>
          </PolicyTable>
        </li>
        <li>
          ② 서비스 이용 시 수집되는 필수 및 선택 항목은 해당 서비스를 제공하기
          위해 수집되는 정보이며, 해당 서비스의 이용 및 데이터 저장 시에만
          수집됩니다. 저장한 데이터를 회원이 삭제하는 경우에는 회원 탈퇴 여부와
          관계없이 수집된 데이터도 그 즉시 삭제됩니다. 또한 개인정보 보호법
          제23조 1항에 의거하여 민감정보에 해당하는 건강정보 수집항목은 별도로
          고지 후 동의를 받습니다.
          <PolicyTable>
            <CaptionHide>
              이용 서비스에 따른 수집 항목, 보유 및 이용기간 안내
            </CaptionHide>
            <colgroup>
              <col style={{ width: "15%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "30%" }} />
              <col style={{ width: "23%" }} />
              <col style={{ width: "12%" }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" colSpan={2}>
                  이용 서비스
                </th>
                <th scope="col">수집 항목</th>
                <th scope="col">수집 목적</th>
                <th scope="col">보유 및 이용 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowSpan={4}>임신준비 다이어리</td>
                <td>임신준비 다이어리 및 캘린더 이용 시</td>
                <td>
                  [필수] 생리기간, 생리주기, 마지막 생리일
                  <br />
                  [선택] 생리시작일, 생리종료일, 배란일, 다이어리 작성일 및 기록
                  항목 (통증, 출혈, 사랑일, 약복용, 예방접종, 병원진료,
                  기초체온, 메모)
                </td>
                <td>
                  생리예정일, 가임기, 배란예정일 예측 및 생리주기별 맞춤형
                  콘텐츠 제공
                </td>
                <td rowSpan={12}>
                  <strong>
                    회원 탈퇴 시 즉시 삭제
                    <br />
                    (단, 제 10조 가명정보처리에 명시된 데이터는 회원 탈퇴 시
                    식별 불가하도록 가명처리 후 보유)
                  </strong>
                </td>
              </tr>
              <tr>
                <td>배란일 체커 이용 시</td>
                <td>[필수] 테스트 일시, 테스트 사진, 테스트 결과</td>
                <td>배란테스트 자동 결과 판독 </td>
              </tr>
              <tr>
                <td>임테기 기록 이용 시</td>
                <td>[필수] 테스트 일시, 테스트 사진, 테스트 결과</td>
                <td>임신테스트 결과 기록 및 열달맘톡 공유 </td>
              </tr>
              <tr>
                <td>난임 모드 이용 시</td>
                <td>
                  [필수] 시술 방법, 시술 차수, 난임 시술 시작 및 종료일,
                  약물/주사 기록, 시술 내용
                </td>
                <td>난임 스케줄 관리 및 약물/주사 투약 알림</td>
              </tr>
              <tr>
                <td rowSpan={3}>임신 다이어리</td>
                <td>임신 다이어리 및 캘린더 이용 시</td>
                <td>
                  [필수] 출산예정일, 태명
                  <br />
                  [선택] 다이어리 작성일 및 기록 항목 (병원진료, 예방접종,
                  체중기록, 사랑일, 메모)
                </td>
                <td>
                  다이어리 기록 및 출산예정일 d-day, 임신 주차별 맞춤형 콘텐츠
                  제공
                </td>
              </tr>
              <tr>
                <td>태아성장보고서 이용 시</td>
                <td>
                  [필수] 기록일(임신 주수 및 일수),
                  항목별수치(EFW/AC/FL/BPD/HC/CRL)
                  <br />
                  [선택] 초음파 사진
                </td>
                <td>주차별/일별 퍼센타일 계산에 따른 태아성장보고서 제공</td>
              </tr>
              <tr>
                <td>산모체중관리 이용 시</td>
                <td>[필수] 임신전체중/키, 체중기록일(임신 주수), 기록체중</td>
                <td>
                  주차별 체중 증가량, 증가율, BMI 계산 및 퍼센타일 계산에 따른
                  산모체중보고서 제공
                </td>
              </tr>
              <tr>
                <td>육아 다이어리</td>
                <td>산후체중관리 이용 시</td>
                <td>
                  [필수] 임신전체중/키, 출산 직전 주차 체중
                  <br />
                  [선택] 체중기록일, 기록체중
                </td>
                <td>52주 체중 관리 플랜 설정</td>
              </tr>
              <tr>
                <td>열달맘톡</td>
                <td>글 또는 댓글 작성 시</td>
                <td>[필수] 닉네임</td>
                <td>
                  이벤트 참여 시 본인 식별 및 게시판 도배, 광고글 작성 등 운영
                  원칙에 어긋나는 부정 이용 확인 및 방지
                </td>
              </tr>
              <tr>
                <td>우리 아이 키 예측</td>
                <td>키 예측 서비스 이용 시</td>
                <td>[필수] 아빠의 키, 엄마의 키</td>
                <td>자녀 예상 키 산출 및 성장 분석 제공</td>
              </tr>
              <tr>
                <td rowSpan={2}>마이메뉴</td>
                <td>내 정보 입력 시</td>
                <td>[선택] 프로필 이미지, 닉네임</td>
                <td>서비스 이용 시 실명 대체</td>
              </tr>
              <tr>
                <td>내 장소 등록 시</td>
                <td>
                  [선택] 활동 지역 정보, 나의 병원 정보, 나의 산후조리원 정보
                  (방문한 산후조리원, 조리기간 등){" "}
                </td>
                <td>맞춤형 모임 추천</td>
              </tr>
              <tr>
                <td>고객센터</td>
                <td>1:1 문의 시</td>
                <td>[필수] 이메일 주소</td>
                <td>상담 또는 불만 처리</td>
                <td>
                  <strong>답변 종료 후 30일 이내 파기</strong>
                </td>
              </tr>
            </tbody>
          </PolicyTable>
        </li>
        <li>
          ③ 서비스 이용 과정에서 아래와 같이 회원의 자녀에 대한 개인정보를
          수집합니다. 이 경우 회사는 회원에게 자녀의 법정대리인으로서 개인정보
          수집 및 이용에 대한 동의를 받습니다.
          <PolicyTable>
            <CaptionHide>
              이용 서비스에 따른 수집 항목, 보유 및 이용기간 안내
            </CaptionHide>
            <colgroup>
              <col style={{ width: "15%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "30%" }} />
              <col style={{ width: "23%" }} />
              <col style={{ width: "12%" }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" colSpan={2}>
                  이용 서비스
                </th>
                <th scope="col">수집 항목</th>
                <th scope="col">수집 목적</th>
                <th scope="col">보유 및 이용 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowSpan={4}>육아 다이어리</td>
                <td>육아 다이어리 이용 시</td>
                <td>
                  [필수] 자녀의 이름, 성별, 생년월일, 출생 시 체중
                  <br />
                  [선택] 출생 시 키, 출생 시 머리둘레, 출산예정일, 건강검진
                  기록, 예방접종 기록
                </td>
                <td>월령별 맞춤형 서비스 제공 및 건강검진, 예방접종 알림</td>
                <td rowSpan={4}>
                  <strong>
                    회원 탈퇴 시 즉시 삭제
                    <br />
                    (단, 제 10조 가명정보처리에 명시된 데이터는 회원 탈퇴 시
                    식별 불가하도록 가명처리 후 보유)
                  </strong>
                </td>
              </tr>
              <tr>
                <td>성장 관리 이용 시</td>
                <td>
                  [필수] 측정일 및 측정수치 (체중, 키, 머리둘레 중 1개 이상)
                </td>
                <td>퍼센타일 계산 및 아이 성장보고서 제공</td>
              </tr>
              <tr>
                <td>발달 체크 이용 시</td>
                <td>
                  [필수] 월령별 발달체크 항목별 기록, 항목별 점수, 사진
                  <br />
                  [선택] 이른둥이 여부, 사진
                </td>
                <td>월령별 발달 체크 미션 및 결과 보고서 제공</td>
              </tr>
              <tr>
                <td>열관리 이용 시</td>
                <td>
                  [필수] 자녀 체중, 체온 기록, 복약 기록
                  <br />
                  [선택] 질병 기록
                </td>
                <td>체온 추이 및 열관리 보고서 제공</td>
              </tr>
            </tbody>
          </PolicyTable>
        </li>
        <li>
          ④ 서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로
          생성되어 수집될 수 있습니다.
          <PolicyHyphenList>
            <li>
              IP Address, 쿠키, 방문 일시, 서비스 이용 기록 (‘열달후에’
              애플리케이션 버전 및 가입일, 이용중인 다이어리 모드 및 다이어리
              저장 기록 등), 부정 이용 기록, 기기정보 (ADID 및 IDFA 등
              기기고유식별값, OS버전, 단말기 모델명 등)
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          ⑤ 부가 서비스 및 맞춤식 서비스 이용 또는 이벤트 응모 과정에서 해당
          서비스의 이용자에 한해서만 아래와 같은 정보들이 수집될 수 있습니다.
          <br />
          이벤트 응모는 ‘열달후에’에서 운영하는 소셜미디어(카카오채널,
          인스타그램, 블로그 등) 및 홈페이지, 앱 등을 통하여 진행하는 이벤트에
          참여한 이용자를 의미합니다.
          <PolicyHyphenList>
            <li>성명, 휴대전화번호, 주소, 이메일 등 개인식별정보</li>
          </PolicyHyphenList>
        </li>
        <li>
          ⑥ 수집경로에 따라 수집하는 항목이 추가되는 경우 수집하는 화면에서
          별도로 고지하고 동의를 받습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>나. 개인정보 수집방법</PolicyArticleTitle>
      <PolicyText>
        회사는 다음과 같은 방법으로 개인정보를 수집하며 정보 주체의 사전 동의
        없이는 정보주체의 개인정보를 공개하지 않습니다.
      </PolicyText>
      <PolicyHyphenList>
        <li>
          임신준비 다이어리, 임신 다이어리, 육아 다이어리, 열달맘톡, 찾기 등의
          ‘열달후에’ 서비스 이용, 서면양식, 팩스, 전화(인 콜/아웃 콜), 1:1
          문의게시판, 이메일, 이벤트 응모 등
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle id="privacy04">
        04. 수집하는 개인정보의 보유 및 이용기간
      </PolicySectionTitle>
      <PolicyText>
        회사가 수집하는 개인정보의 보유 및 이용기간은 정보주체가 회사에서
        제공하는 서비스를 이용하는 동안 회원 탈퇴를 요청하거나 개인정보의
        수집·이용 등에 대한 동의를 철회할 때까지 보존합니다. 다만, 아래의 "06.
        정보주체 자신의 개인정보 관리(열람, 정정, 삭제 등)에 관한 사항" 에서
        설명한 절차와 방법에 따라 회원 본인이 직접 삭제(탈퇴)를 요청한 경우에는
        재생할 수 없는 방법에 의하여 디스크에서 완전히 삭제하며 추후 열람이나
        이용이 불가능한 상태로 처리됩니다. 그리고 "03. 수집하는 개인정보 항목 및
        수집방법"에서와 같이 일시적인 목적 (설문조사, 이벤트, 본인확인 등)으로
        입력 받은 개인정보는 그 목적이 달성된 이후에는 동일한 방법으로 사후
        재생이 불가능한 상태로 처리됩니다. 또한 「상법」, 「전자상거래 등에서의
        소비자보호에 관한 법률」 등 관계법령의 규정에 의하여 보존할 필요가 있는
        경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이
        경우 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와
        같습니다.
      </PolicyText>
      <PolicyTable>
        <CaptionHide>
          수집하는 개인정보의 보유 목적 및 항목, 근거, 이용 기간 안내
        </CaptionHide>
        <colgroup>
          <col />
          <col />
          <col />
          <col style={{ width: "15%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">보유목적</th>
            <th scope="col">보유항목</th>
            <th scope="col">보유근거</th>
            <th scope="col">보유/이용 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>통신사실확인 자료 제공</td>
            <td>로그기록, 접속지 정보 등</td>
            <td>「통신비밀보호법」</td>
            <td>
              <strong>3개월</strong>
            </td>
          </tr>
          <tr>
            <td>표시/광고에 관한 기록</td>
            <td>표시/광고에 관한 기록</td>
            <td rowSpan={4}>「전자상거래 등에서의 소비자 보호에 관한 법률」</td>
            <td>
              <strong>6개월</strong>
            </td>
          </tr>
          <tr>
            <td>대금결제 및 재화 등의 공급에 관한 기록</td>
            <td>대금결제 및 재화 등의 공급에 관한 기록</td>
            <td>
              <strong>5년</strong>
            </td>
          </tr>
          <tr>
            <td>계약 또는 청약 철회 등에 관한 기록</td>
            <td>소비자 식별정보 계약/청약철회 기록</td>
            <td>
              <strong>5년</strong>
            </td>
          </tr>
          <tr>
            <td>소비자 불만 또는 분쟁처리에 관한 기록</td>
            <td>소비자 식별정보 분쟁처리 기록</td>
            <td>
              <strong>3년</strong>
            </td>
          </tr>
        </tbody>
      </PolicyTable>

      <PolicySectionTitle id="privacy05">
        05. 수집한 개인정보의 공유 및 제공
      </PolicySectionTitle>
      <PolicyText>
        회사는 정보주체가 개인정보를 "02. 개인정보의 수집 및 이용목적"에서
        고지한 범위 내에서 사용하며, 정보주체의 사전 동의 없이는 동 범위를
        초과하여 이용하거나 원칙적으로 정보주체의 개인정보를 외부에 제공하지
        않습니다. 다만, 아래의 경우에는 예외로 합니다.
      </PolicyText>
      <PolicyHyphenList>
        <li>정보주체가 사전에 개인정보 제공에 동의한 경우</li>
        <li>회사의 서비스 제공에 따른 요금 정산을 위하여 필요한 경우</li>
        <li>
          앱 또는 홈페이지에 게시한 서비스 이용 약관 및 기타 회원 서비스 등의
          이용약관 또는 운영원칙을 위반한 경우
        </li>
        <li>
          회사의 서비스를 이용하여 타인에게 정신적, 물질적 피해를 줌으로써 그에
          대한 법적인 조치를취하기 위하여 개인정보를 제공해야 한다고 판단되는
          충분한 근거가 있는 경우
        </li>
        <li>
          기타 법에 의해 요구된다고 선의로 판단되는 경우 (ex. 관련법에 의거
          적법한 절차에 의한 정부/수사기관의 요청이 있는 경우 등
        </li>
        <li>
          통계작성, 학술연구나 시장조사를 위하여 특정 개인을 식별할 수 없는
          형태로 연구단체 등에 제공하는 경우
        </li>
      </PolicyHyphenList>
      <PolicySectionTitle id="privacy06">
        06. 정보주체 자신의 개인정보 관리(열람, 정정, 삭제 등)에 관한 사항
      </PolicySectionTitle>
      <PolicyList>
        <li>
          1. 정보주체는 회사에 대해 언제든지 다음의 개인정보 보호 관련 권리를
          행사할 수 있습니다.
          <ul>
            <li>① 개인정보 열람요구</li>
            <li>② 오류 등이 있을 경우 정정 요구</li>
            <li>③ 삭제요구</li>
            <li>④ 처리정지 요구</li>
          </ul>
        </li>
        <li>
          2. 제1항에 따른 권리 행사는 회사에 대해 서면, 전화를 통하여 하실 수
          있으며 회사는 이에 대해 지체없이 조치하겠습니다.
        </li>
        <li>
          3. 정보주체가 개인정보의 오류 등에 대해 정정 또는 삭제를 요구한
          경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를
          이용하거나 제공하지 않습니다.
        </li>
        <li>
          4. 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자
          등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙
          별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
        </li>
        <li>
          5. 정보주체는 개인정보 보호법 등 관계법령을 위반하여 회사가 처리하고
          있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는
          아니됩니다.
        </li>
        <li>
          6. 정보주체는 언제든지 ‘회원탈퇴’ 등을 통해 개인정보의 수집 및 이용
          동의를 철회할 수 있습니다.
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy07">
        07. 개인정보 자동수집 장치의 설치·운영 및 그 거부에 관한 사항
      </PolicySectionTitle>
      <PolicyArticleTitle>
        가. 쿠키(cookie)의 운영에 관한 사항
      </PolicyArticleTitle>
      <PolicyText>
        회사는 이용자들에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의
        정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는
        웹사이트를 운영하는데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게
        보내는 소량의 정보이며 이용자들의 PC 컴퓨터 또는 스마트폰 내의
        하드디스크에 저장되기도 합니다. 이용자들이 홈페이지에 접속한 후
        로그인하여 회원서비스 등의 서비스를 이용하기 위해서는 쿠키를 허용하셔야
        합니다. 회사는 이용자들에게 적합하고 보다 유용한 서비스를 제공하기
        위해서 쿠키를 이용하여 아이디에 대한 정보를 찾아냅니다. 쿠키는
        정보주체의 컴퓨터 또는 스마트폰 단말기의 속성은 식별하지만 정보주체자를
        개인적으로 식별하지는 않습니다.
      </PolicyText>
      <PolicyList>
        <li>
          <strong>1. 쿠키의 사용 목적</strong>
          <br />
          이용자들이 방문한 회사가 제작한 사이트의 각 서비스와 웹 사이트들에
          대한 방문 및 이용형태,보안접속 여부 등을 파악하여 이용자에게 최적화된
          정보 제공을 위하여 사용합니다.
        </li>
        <li>
          <strong>2. 쿠키의 사용 설정</strong>
          <br />
          이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는
          웹 브라우저에서 옵션을설정함으로써 모든 쿠키를 허용하거나, 쿠키가
          저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도
          있습니다. 쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹
          브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할
          때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
          <br />
          <br />- 설정방법 예(인터넷 익스플로러의 경우) : 웹 브라우저 상단의
          도구 &gt; 인터넷 옵션 &gt; 개인정보
          <br />
          <br />
          다만, 쿠키의 저장을 거부할 경우에는 추후 로그인이 필요한 일부 서비스는
          이용에 어려움이 있을 수 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        나. 고객 행동 및 마케팅 분석 운영에 대한 사항
      </PolicyArticleTitle>
      <PolicyText>
        회사는 사용자 행태 분석 서비스와 온라인 맞춤형 광고를 이용하고 있으며
        해당 사업자가 개인식별정보 없이 서비스 이용행태정보를 수집하도록
        허용하고 있습니다.‘열달후에’ 앱은 이용자의 ADID/IDFA를 수집할 수
        있습니다. ADID(Android OS)/IDFA(iOS)란 모바일앱 이용자의 광고 식별
        값으로서, 사용자의 맞춤 서비스 제공이나 더 나은 환경의 광고를 제공하기
        위한 측정을 위해 수집될 수 있습니다.{" "}
      </PolicyText>
      <PolicyHyphenListBox>
        <PolicyText>[거부방법]</PolicyText>
        <PolicyHyphenList>
          <li>
            Android : 설정 &gt; 구글(구글설정) &gt; 광고 &gt; 광고 맞춤설정 선택
            해제
          </li>
          <li>iOS : 설정 &gt; 개인정보보호 &gt; 광고 &gt; 광고 추적 제한</li>
        </PolicyHyphenList>
      </PolicyHyphenListBox>
      <PolicyText>
        사용자는 언제든지 이러한 맞춤형 광고 수신을 거부할 수 있으며, 이 경우
        맞춤형 광고가 아닌 임의의 광고가 노출됩니다.
      </PolicyText>

      <PolicySectionTitle id="privacy08">
        08. 개인정보 파기 절차 및 방법
      </PolicySectionTitle>
      <PolicyText>
        회사는 수집한 개인정보의 이용 목적이 달성된 후에는 보관 및 이용 기간에
        따라 해당 정보를 바로 파기합니다. 다만 내부 방침에 의해 서비스
        부정이용기록은 부정 가입 및 이용 방지를 위하여 회원 탈퇴 시점으로부터
        최대 1년간 보관 후 파기하며, 관계법령에 의해 보관해야 하는 정보는 법령이
        정한 기간 동안 보관한 후 파기합니다. 파기 절차, 방법, 시점은 다음과
        같습니다.
      </PolicyText>
      <PolicyArticleTitle>가. 파기절차</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① 회원이 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의
          데이터베이스(DB)로 옮겨져 회사의 내부 방침과 관련 법령에 따른 정보보호
          사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.
        </li>
        <li>
          ② 별도의 데이터베이스(DB)로 옮겨진 개인정보는 법령에 따른 경우가
          아니면 보유 목적 이외의 다른 용도로 이용되지 않습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>나. 파기방법</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없게 하는
          기술적 방법으로 삭제합니다.
        </li>
        <li>
          ② 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy09">
        09. 가명정보의 처리
      </PolicySectionTitle>
      <PolicyText>
        회사는 수집한 개인정보를 특정 개인을 알아볼 수 없도록 가명 처리하여
        통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 처리할 수 있습니다.
        가명정보 처리의 위탁 및 제3자 제공은 하지 않으며, 가명정보는 재식별 되지
        않도록 분리하여 별도 저장·관리하고 가명정보의 처리 내용에 대해 기록을
        작성하여 보관하는 등 필요한 기술적·관리적 보호조치를 취합니다.
      </PolicyText>
      <PolicyTable>
        <CaptionHide>가명정보의 처리 항목 안내</CaptionHide>
        <colgroup>
          <col style={{ width: "35%", maxWidth: 200 }} />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th scope="col" colSpan={2}>
              처리항목
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>임신준비 다이어리</td>
            <td className="cell_left">
              가명 처리된 사용자 key
              <br />
              - 생년월일(나이)
              <br />
              - 설정된 생리주기
              <br />
              - 설정된 생리기간
              <br />
              - 사용자가 저장한 생리 시작일, 종료일, 배란일 히스토리
              <br />
              - 배테기 기록 (기록일, 수치, 이미지)
              <br />- 임테기 기록 (기록일, 수치, 이미지)
            </td>
          </tr>
          <tr>
            <td>임신 다이어리</td>
            <td className="cell_left">
              가명 처리된 사용자 key, 가명 처리된 임신 정보 key
              <br />
              - 태아성장기록 (기록일, 주수일수, EFW/AC/FL/BPD/HC 수치)
              <br />- 산모체중기록 (임신전체중/키, 기록, 주수, 체중)
            </td>
          </tr>
          <tr>
            <td>육아 다이어리</td>
            <td className="cell_left">
              가명 처리된 자녀 key
              <br />
              - 자녀 생년월일 (출산예정일)
              <br />
              - 성장기록(기록일, 자녀 월령, 키, 몸무게, 머리둘레 수치)
              <br />
              - 발달기록(기록일, 미션완료일, 미션 차수, 문항별 점수, 문항별
              미션성공일자)
              <br />
              - 열관리기록(체중, 질병기록, 체온기록, 복약기록)
              <br />
              가명 처리된 사용자 key, 가명 처리된 임신 정보 key
              <br />- 임신전체중/키, 주수, 체중
            </td>
          </tr>
        </tbody>
      </PolicyTable>

      <PolicySectionTitle id="privacy10">
        10. 개인정보 관련 기술적 및 관리적 보호 대책
      </PolicySectionTitle>
      <PolicyText>
        회사는 이용자의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출,
        변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적
        대책을 강구하고 있습니다.
      </PolicyText>
      <PolicyArticleTitle>가. 기술적 대책</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① 고객님의 개인정보는 암호알고리즘을 이용하여 안전하게 보호·저장되고
          있으며 네트워크상의 전송데이터를 암호화하거나 파일 잠금 기능 (Lock)을
          사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.
        </li>
        <li>
          ② 회사는 백신프로그램을 이용하여 컴퓨터 바이러스의 피해를 방지하고
          있습니다. 백신프로그램은 주기적으로 업데이트되며 바이러스가 갑작스럽게
          출현할 때에는 백신이 나오는 즉시 제공함으로써 개인정보가 침해되는 것을
          방지하고 있습니다.
        </li>
        <li>
          ③ 회사는 해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및
          취약점 분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.
        </li>
      </PolicyList>
      <PolicyArticleTitle>나. 관리적 대책</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① 회사는 개인정보의 안전한 보호를 위하여 외부 전문기관으로부터
          정보보호관리체계 등에 대한 객관적인 인증을 받아 주요 시스템과 설비를
          운영하고 있습니다.
        </li>
        <li>
          ② 회사는 고객님의 개인정보에 대한 접근과 관리에 필요한 절차 등을
          마련하여 소속 직원으로 하여금 이를 숙지하여 준수하도록 하고 있으며,
          개인정보를 취급하는 직원을 대상으로 새로운 보안 기술 습득 및
          개인정보보호 의무 등에 관한 정기적인 사내 교육을 시행하고 있습니다.
        </li>
        <li>
          ③ 회사는 고객님의 개인정보에 대한 접근권한을 최소한의 인원으로
          제한하고 있습니다.
        </li>
        <li>
          ④ 개인정보 관련 취급자의 업무 인수인계는 보안이 유지된 상태에서
          철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을
          명확히 하고 있습니다.
        </li>
        <li>
          ⑤ 회사는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는
          일에 대해 책임을 지지 않습니다.
        </li>
        <li>
          ⑥ 그 밖에 내부 관리자의 실수나 기술 관리상의 사고로 개인정보의 상실,
          유출, 변조, 훼손이 유발되면 회사는 즉각 고객님께 그 사실을 알리고
          적절한 대책과 보상을 마련할 것입니다.
        </li>
        <li>
          ⑦ 전산실과 자료 보관실 등을 특별보호구역으로 설정하여 출입을 통제하고
          있습니다.
        </li>
        <li>
          ⑧ 회사가 컴퓨터를 이용하여 고객의 개인정보를 처리할 때에는 개인정보에
          대한 접근 권한이 있는 담당자를 지정하여 식별 부호(ID)와
          비밀번호(PASSWORD)를 부여하고, 해당 비밀번호(PASSWORD)를 정기적으로
          갱신하고 있습니다.
        </li>
        <li>
          ⑨ 회사는 신규직원을 채용할 때 정보보호서약서 또는 개인정보보호서약서에
          서명하게 하여 직원에 의한 정보유출을 사전에 방지하고 있으며
          개인정보처리방침에 대한 이행사항과 직원의 준수 여부를 감사하기 위한
          내부 절차를 마련해 지속적으로 시행하고 있습니다.
        </li>
        <li>
          ⑩ 회사는 직원이 퇴직할 때 비밀유지서약서에 서명하게 함으로써 고객의
          개인정보를 취급하였던 자가 직무상 알게 된 개인정보를 훼손, 침해 또는
          누설하지 않도록 하고 있습니다.
        </li>
        <li>
          ⑪ 서비스 이용계약 체결, 서비스 제공 등을 위하여 고객의 신용카드번호,
          은행결제계좌 등 대금결제에 관한 정보를 수집하거나 고객에게 제공할 때
          회사는 해당 고객이 본인임을 확인하도록 조치하고 있습니다.
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy11">
        11. 개인정보의 위탁처리
      </PolicySectionTitle>
      <PolicyList>
        <li>
          ① 회사는 서비스 향상을 위해서 정보주체들의 개인정보를 외부전문업체에
          위탁하여 처리할 수 있습니다. 개인정보의 처리를 위탁하는 경우에는 미리
          그 사실을 정보주체자에게 공지할 것입니다. 다만 법령의 규정에
          의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의
          요구가 있는 경우는 예외로 하고 있습니다. 또한 위탁계약 등을 통하여
          서비스제공자의 개인정보보호 관련 지시엄수, 개인정보에 관한 비밀유지,
          제3자 제공의 금지 및 사고시의 책임부담 등을 명확히 규정하고 당해
          계약내용을 서면 또는 전자적으로 보관할 것입니다.
          <PolicyTable>
            <caption>[위탁업체 및 위탁 업무]</caption>
            <thead>
              <tr>
                <th scope="col">위탁업체</th>
                <th scope="col">위탁 업무 내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>㈜ 다날</td>
                <td>본인확인</td>
              </tr>
              <tr>
                <td>
                  LGU+
                  <br />
                  ㈜카카오
                  <br />
                  ㈜NHN(토스트)
                </td>
                <td>SMS 및 메시지 발송</td>
              </tr>
              <tr>
                <td>NAVER Business Platform</td>
                <td>데이터 보관</td>
              </tr>
              <tr>
                <td>AWS</td>
                <td>데이터 보관</td>
              </tr>
            </tbody>
          </PolicyTable>
        </li>
        <li>
          ② 회사는 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무
          수행목적 외 개인정보 처리금지, 기술적∙관리적 보호조치, 재위탁 제한,
          수탁자에 대한 관리∙감독, 손해배상 등 책임에 관한 사항을 계약서 등
          문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고
          있습니다.
        </li>
        <li>
          ③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보
          처리방침을 통하여 공개하도록 하겠습니다.
        </li>
      </PolicyList>

      <PolicySectionTitle id="privacy12">
        12. 개인정보관련 의견수렴 및 불만처리에 관한 사항
      </PolicySectionTitle>
      <PolicyText>
        회사는 개인정보보호와 관련하여 정보주체 여러분들의 의견을 수렴하고
        있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다.
        정보주체들은 하단에 명시한 "15. 고객센터 안내"항을 참고하여 전화나
        메일을 통하여 불만사항을 신고할 수 있고, 회사는 정보주체들의 신고사항에
        대하여 신속하고도 충분한 답변을 해 드릴 것입니다.
      </PolicyText>
      <PolicyText>
        &lt;아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보
        불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이
        필요하시면 고객센터로 문의하여 주시기 바랍니다.&gt;
      </PolicyText>
      <PolicyHyphenList>
        <li>개인정보 분쟁조정위원회 : 1833-6972 (www.kopico.go.kr)</li>
        <li>개인정보 침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
        <li>
          대검찰청 사이버수사과 : (국번없이) 1301, privacy@spo.go.kr
          (www.spo.go.kr)
        </li>
        <li>경찰청 사이버안전국 : (국번없이) 182 (cyberbureau.police.go.kr)</li>
      </PolicyHyphenList>

      <PolicySectionTitle id="privacy13">
        13. 정보주체의 권리와 의무
      </PolicySectionTitle>
      <PolicyText>
        정보주체가 입력한 부정확한 정보로 인해 발생하는 사고의 책임은 자신에게
        있으며 타인 정보의 도용 등 허위정보를 입력할 경우 회원자격이 상실될 수
        있습니다. 정보주체는 개인정보를 보호받을 권리와 함께 스스로를 보호하고
        타인의 정보를 침해하지 않을 의무도 가지고 있습니다. 개인정보가 유출되지
        않도록 조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록
        유의해 주십시오. 정보주체가 위 책임을 다하지 못하고 타인의 정보 및
        존엄성을 훼손할 시에는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등
        관련 법률에 의해 처벌받을 수 있습니다.
      </PolicyText>

      <PolicySectionTitle id="privacy14">14. 고객센터 안내</PolicySectionTitle>
      <PolicyText>
        현재 회사는 고객의 민원 사항의 처리를 위해 본사에서 운영하고 있습니다.
        회사는 위탁업체에 고객의 민원사항 처리를 위해 필요한 범위 내에서 정보를
        제공할 수 있습니다. 또한 위탁계약 시 개인정보 보호의 안전을 기하기
        위하여 서비스 제공자의 개인정보보호 관련 지시엄수, 개인정보에 관한
        비밀유지, 제 3자 제공의 금지 및 사고시의 책임부담 등을 명확히 규정하고
        당해 계약내용을 서면 및 전자적으로 보관하고 있습니다. 현재 고객센터의
        운영현황과 연락처는 다음과 같습니다.
      </PolicyText>
      <PolicyHyphenList>
        <li>열달후에 고객센터 전화번호 : 02-2135-9542</li>
        <li>
          근무시간 : 평일 09:00~18:00 (일요일, 공휴일은 휴무/변경될 수 있음)
        </li>
        <li>
          등기우편 : 서울특별시 마포구 양화로 176, 지하2층 56호 ㈜커넥트아이
          열달후에 서비스 담당자 앞
        </li>
        <li>
          기타문의 : 열달후에 대표메일 after10month@connect-i.co.kr 또는
          열달후에 앱 내 1:1 문의
        </li>
      </PolicyHyphenList>
      <PolicyText>
        그 외 개인정보에 관한 상담이 필요한 경우에는 한국인터넷진흥원(KISA)에서
        운영하는 개인정보 침해신고센터(전화 : 118)로 문의하실 수 있습니다.
      </PolicyText>

      <PolicySectionTitle id="privacy15">
        15. 개인정보 보호 책임자의 소속-성명 및 연락처
      </PolicySectionTitle>
      <PolicyTable>
        <CaptionHide>개인정보 보호 책임자 안내</CaptionHide>
        <colgroup>
          <col style={{ width: "35%" }} />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th scope="col" colSpan={2}>
              개인정보 보호 책임자
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>성명</td>
            <td>류상직</td>
          </tr>
          <tr>
            <td>소속</td>
            <td>(주)커넥트아이</td>
          </tr>
          <tr>
            <td>전화</td>
            <td>02-2135-9542</td>
          </tr>
          <tr>
            <td>메일</td>
            <td>sjryu@connect-i.co.kr</td>
          </tr>
        </tbody>
      </PolicyTable>

      <PolicySectionTitle id="privacy16">
        16. 본 개인정보처리방침의 적용 범위
      </PolicySectionTitle>
      <PolicyText>
        본 개인정보처리방침은 회사의 브랜드 중 하나인 ‘열달후에’ 및 관련 제반
        서비스에 적용되며, 다른 브랜드로 제공되는 서비스에 대해서는 별개의
        개인정보처리방침이 적용될 수 있습니다. ‘열달후에’에 링크되어 있는 다른
        회사의 웹사이트에서 개인정보를 수집하는 경우, 이용자 동의 하에
        개인정보가 제공된 이후에는 본 개인정보처리방침이 적용되지 않습니다.
      </PolicyText>

      <PolicySectionTitle id="privacy17">17. 고지의 의무</PolicySectionTitle>
      <PolicyText>
        현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소
        7일전부터 서비스 내 '공지사항'을 통해 고지합니다.
      </PolicyText>
      <PolicyHyphenList>
        <li>개인정보처리방침 버전번호 : 3.0</li>
        <li>개인정보처리방침 공고일자 : 2026년 04월 15일</li>
        <li>개인정보처리방침 시행일자 : 2026년 04월 22일</li>
      </PolicyHyphenList>
    </PolicyContainer>
  );
};

export default Privacy;
